import React from 'react';
import { Box, Text } from '@mantine/core';

const BetaBanner: React.FC = () => {
  return (
    <Box
      px="md"
      py={6}
      style={{
        background:
          'linear-gradient(90deg, rgba(255,179,71,0.3) 0%, rgba(255,99,71,0.3) 100%), #1b1b1b',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
      }}
    >
      <Text c="white" fz="sm" fw={600} ta="center">
        Beta version: features may change and occasional instability can occur.
      </Text>
    </Box>
  );
};

export default BetaBanner;
